import { useState } from 'react'
import type { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ApiError } from '@/lib/api'
import { useThemeEffect } from '@/lib/hooks/useTheme'

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        // Never retry a request that failed for a reason retrying cannot fix
        // (bad token, disabled route, missing LLM config).
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isRetryable) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })
}

export function AppProviders({ children }: { children: ReactNode }) {
  // Created once per app instance rather than at module scope, so a hot reload
  // or a test remount gets a clean cache.
  const [queryClient] = useState(createQueryClient)

  useThemeEffect()

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
